import React, { useState, useEffect } from 'react';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import ParentChat from './ParentChat';
import './ParentChatPage.css';

const ParentChatPage = () => {
  const [displayName, setDisplayName] = useState('');
  const [accessGate, setAccessGate] = useState('loading');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      (async () => {
        if (!user) {
          window.location.href = '/login';
          return;
        }
        setDisplayName(user.displayName || '');
        setAccessGate('loading');
        try {
          const snap = await getDoc(doc(db, 'parents', user.uid));
          if (!snap.exists()) {
            await signOut(auth);
            window.location.href = '/login?setup=1';
            return;
          }
          if (snap.data().accessEnabled === false) {
            await signOut(auth);
            window.location.href = '/login?revoked=1';
            return;
          }
          setAccessGate('ok');
        } catch (err) {
          console.error(err);
          setAccessGate('error');
        }
      })();
    });
    return () => unsub();
  }, []);

  if (accessGate === 'loading') {
    return (
      <div className="parent-chat-page parent-chat-page--gate">
        <p className="parent-chat-page-gate-msg">Loading…</p>
      </div>
    );
  }

  if (accessGate === 'error') {
    return (
      <div className="parent-chat-page parent-chat-page--gate">
        <p className="parent-chat-page-gate-msg">
          We could not verify your account.{' '}
          <button type="button" className="parent-chat-page-link-btn" onClick={() => window.location.reload()}>
            Retry
          </button>
        </p>
      </div>
    );
  }

  return (
    <div className="parent-chat-page">
      <h1 className="visually-hidden">Team Discussions</h1>
      <ParentChat displayName={displayName} layout="page" />
    </div>
  );
};

export default ParentChatPage;
